export default __webpack_public_path__ + "static/media/for-players-pro.f6359777.svg";